import Commons from '../../../Services/Common/Common';

export const M_PPE_BASIC_Schema = {
  mapper: {
    /** 보호구 조회(PPE) GetEquipIssueR2 */
    search1: {
      UserId: (context) => context.userInfo?.userid ?? '',
    },
    /** 보호구 체크 여부 저장 SaveEquipLogU1 */
    save1: {
      ErCd: (row) => Commons.EncryptAES(row.erCd ?? '') || '',
      EquipYn: (row) => Commons.EncryptAES(row.equipYn ?? 'N') || '',
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
  },
};
